import createLoader from './createLoader';
import { subscribe, unsubscribe, initialLoad } from './ownExpertLoaderGraphQL/ownExpertLoaderGraphQL';

const ownExpertLoader = createLoader(initialLoad, subscribe, unsubscribe);

export default ownExpertLoader;
